import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export function formatCurrency(value: number, compact: boolean = true): string {
  const formatCompact = (scaledValue: number, suffix: string): string => {
    const rounded = Math.round((scaledValue + Number.EPSILON) * 10) / 10;
    const display = Number.isInteger(rounded) ? rounded.toFixed(0) : rounded.toFixed(1);
    return `$${display}${suffix}`;
  };

  if (compact) {
    if (value >= 1000000) {
      const millions = value / 1000000;
      return formatCompact(millions, "M");
    } else if (value >= 1000) {
      const thousands = value / 1000;
      return formatCompact(thousands, "K");
    }
  }
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}

export function formatDate(date: string | Date, format: "short" | "long" = "short"): string {
  const dateObj = typeof date === "string" ? new Date(date) : date;

  if (format === "long") {
    return dateObj.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  }

  return dateObj.toLocaleDateString("en-US", {
    month: "short",
    year: "numeric",
  });
}

/**
 * Normalizes an account name for comparison.
 * Per user story: case-insensitive, ignore leading/trailing spaces.
 */
export function normalizeAccountName(value: string): string {
  return value.trim().toLowerCase();
}
